<template>
    <div>
        <CommonPopupFrame :changeHeight="100" :closeCompleteAction="closeAction" :isOpen="isOpen" :changeBottom="0" :is-back-press-apply="true">
            <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div>
            <div @click="closeAction" style="padding-left: 12px; margin-top: 6px; font-weight: 700; color: #808080; height: 30px; width: 50px;">닫기</div>
            <div style="flex: 1;">
                <div style="margin-top: 25px;">
                    <div style="font-size: 32px;font-weight: 700;line-height: 46.34px; text-align: center;">포지션 PRO 무료로 하기</div>
                    <div style="font-size: 16px;font-weight: 500;line-height: 24px; margin-top: 8px; text-align: center">딱 한 가지 조건만 달성해보세요.<br>포지션 찾기 PRO를 무료로 진행할 수 있습니다.</div>
                </div>
                <div style="margin-top: 40px; padding: 0 24px;">
                    <div style="height: 224px; display: flex; border: 1px solid #d9d9d9; border-radius: 24px; padding: 48px 24px; gap: 12px;">
                        <div v-if="!isEnterComplete || !isScheduleComplete" class="circle_progress_wrap">
                            <svg class="circle_progress" width="24" height="24" viewBox="0 0 24 24">
                                <circle class="frame" cx="12" cy="12" r="10" stroke-width="4" />
                                <circle :style="{ strokeDashoffset: getProgress + 'px' }" style="stroke-dasharray: 62.8318px;" class="bar" cx="12" cy="12" r="10" stroke-width="4" />
                            </svg>
                        </div>
                        <div v-else>
                            <img style="width: 28px;" :src="require('@/assets/img/complete_quest.png')" alt="">
                        </div>
                        <div style="display: flex; gap: 4px;">
                            <div>
                                <img style="width: 17px;" :src="require('@/assets/free_position_pro.png')" alt="">
                            </div>
                            <div>
                                <div style="font-size:20px; font-weight: 700; line-height: 24px; margin-bottom: 8px;">내가 만든 스케줄에 친구 1명을 참여시키기</div>
                                <div style="font-size: 14px;font-weight: 500;line-height: 24px; color: #606060;">용병을 구하거나 축구 훈련을 같이할 스케줄을 만들고 친구나 회원을 초대하여 스케줄에 참여시키세요. 딱 1명만 참여해도 됩니다.</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="margin-top: 40px; padding: 0 24px;">
                    <div v-if="(!isEnterComplete && !isScheduleComplete) || !isScheduleComplete" @click="makeSchedule" style="border-radius: 30px; padding: 20px; background-color: #210f03; color: #fff; line-height: 24px; text-align: center; font-weight: 500;">스케줄 만들고 PRO 무료로 하기</div>
                    <div v-else-if="(!isEnterComplete || !isScheduleComplete) && !isShareComplete" @click="shareSchedule" style="border-radius: 30px; padding: 20px; background-color: #210f03; color: #fff; line-height: 24px; text-align: center; font-weight: 500;">스케줄 공유하고 PRO 무료로 하기</div>
                    <div v-else-if="(!isEnterComplete || !isScheduleComplete) && isShareComplete" @click="inviteMySchedule" style="border-radius: 30px; padding: 20px; background-color: #210f03; color: #fff; line-height: 24px; text-align: center; font-weight: 500;">내 스케줄에 초대하기</div>
                    <div v-else @click="findPositionPro" style="border-radius: 30px; padding: 20px; background-color: #210f03; color: #fff; line-height: 24px; text-align: center; font-weight: 500;">포지션 찾기 PRO 시작하기</div>
                    <div style="display: flex; align-items: center; gap: 4px; justify-content: center; margin-top: 4px;">
                        <div style="width: 3px; height: 3px; border-radius: 50%; background-color: #210f03;"></div>
                        <div style="font-size: 12px;font-weight: 500;line-height: 20px;">최초 1회만 진행할 수 있습니다</div>
                    </div>
                </div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from "@/components/modal/my/CommonPopupFrame";

export default {
    name: "PositionProFreePopup",
    components: { CommonPopupFrame },
    props: {

    },
    data() {
        return {
            isOpen: false,
            isScheduleComplete: false,
            isEnterComplete: false,
            isShareComplete: false
        }
    },
    computed: {
        getProgress() {
            let progress
            if (this.isScheduleComplete && this.isEnterComplete) {
                progress = 0
            } else if ((!this.isScheduleComplete && this.isEnterComplete) || (this.isScheduleComplete && !this.isEnterComplete)) {
                if (this.isShareComplete) {
                    progress = 15.8318
                } else {
                    progress = 32.4149
                }
            } else if (!this.isScheduleComplete && !this.isEnterComplete) {
                progress = 62.8318
            }

            return progress
        }
    },
    methods: {
        inviteMySchedule() {
            this.$GlobalStore.addModal('InviteMemberPopup', { transitionName: '', isModalBackTransparent: true, region_code: this.$GlobalStore.shareRegionCode() })
        },
        async shareSchedule() {
            const res = await this.$Axios.get('/api/join/schedule/latest/one')

            this.$GlobalStore.addModal('MercenaryScheduleDetailPopup', { transitionName: '', isModalBackTransparent: true, schedule_idx: res.data.join_schedule.idx });
        },
        async checkCondition() {
            const res = await this.$Axios.get('/api/position/free/check')
            const isShareComplete = JSON.parse(localStorage.getItem('isShared'))

            if (isShareComplete) {
                this.isShareComplete = true
            }
            this.isScheduleComplete = res.data.isScheduleComplete
            this.isEnterComplete = res.data.isShareComplete

            // this.isScheduleComplete = false
            // this.isEnterComplete = true
        },
        findPositionPro() {
            this.$GlobalStore.closeLastModal()
            this.$GlobalStore.addModal('MyPositionPro', { is_free: true });
        },
        closeAction() {
            if (this.isOpen) {
                this.isOpen = false;
                return;
            }
            setTimeout(() => {
                this.$GlobalStore.closeLastModal();
            }, 300)
        },
        ActBeforeClose() {
            this.isOpen = false;
        },
        makeSchedule() {
            this.$GlobalStore.closeLastModal()
            this.$GlobalStore.addModal('NewMakeMercenarySchedule', {
                joinIdx: 0, isOpen: true,
                completeAction: () => {

                }
            })
        }
    },
    mounted() {
        setTimeout(() => {
            this.isOpen = true;
        }, 100)
    },
    created() {
        this.checkCondition()
    }
}
</script>

<style scoped>
.circle_progress_wrap {
    position: relative;
    width: 24px;
    height: 24px;
}

.circle_progress {
    transform: rotate(-90deg);
}

.frame,
.bar {
    fill: none;
}

.frame {
    stroke: #ebebeb;
}

.bar {
    stroke: var(--color-main);
    stroke-linecap: round;
}

.value {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    text-align: center;
    color: #888;
    font-size: 16px;
    line-height: 120px;
}
</style>